import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'


class ImagesView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
    const list = container.querySelectorAll('.item-image-md--copy');
    list.forEach(this.hideImage);
    // only hide animation
    
  }
  hideImage = (el, index) => {
    gsap.killTweensOf(el);
    const rect = el.getBoundingClientRect();
    const wW = window.innerWidth;
    const offsetX = wW * .25;
    const myX = gsap.getProperty(el, 'x');
    const x = index % 2 ? myX + offsetX : myX - offsetX;
    gsap.to(el, {
      x,
      y: - window.innerHeight,
      duration: .7,
      ease: 'power2.in',
      delay: index * .02,
    });
  }

}

export default ImagesView